import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the partnersCountriesView.
 * @extends JetView
 */
export default class partnersCountriesView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        var list1 = {
            view: 'dbllist', // Double list view
            id: 'dbllist', // Unique identifier for the double list
            list: {
                height: 0, // Height of the list
                scroll: true, // Enable scrolling
            },
            labelLeft: _('Países no agregados'), // Left label for unadded countries
            labelRight: _('Países Agregados'), // Right label for added countries
            data: [], // Initial data for the list
        };
        return {
            view: 'form', // Form view
            id: 'f1', // Unique identifier for the form
            rows: [
                {
                    view: 'forminput', // Input field in the form
                    name: 'access', // Name of the input field
                    body: list1, // Body of the input field
                    labelWidth: 140, // Width of the label
                    labelAlign: 'right', // Alignment of the label
                },
            ],
        };
    }

    /**
     * Initializes the view and fetches data.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        var values = ''; // Variable to hold included countries
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        webix
            .ajax() // AJAX request to fetch partner countries
            .get(devConfig.geturlApi() + 'PartnersCountries/GetPartnersCountries?Partner=' + id_partner, {
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text); // Parse the response text
                    if (!data.HasError) {
                        // Check for errors
                        $$('dbllist').$$('left').clearAll(); // Clear left list
                        $$('dbllist').setValue([]); // Reset selected values
                        $$('dbllist').parse(
                            data.Data.ExcludedCountriesList, // Parse excluded countries
                        );
                        $$('dbllist').setValue(
                            data.Data.IncludedCountriesList, // Set included countries
                        );
                        if (data.Data.IncludedCountriesList != null) {
                            values = data.Data.IncludedCountriesList; // Store included countries
                        }
                    }
                },
            });
        $$('dbllist').attachEvent('onChange', function (id, e, node) {
            // Attach change event to the double list
            var array1 = values.split(','); // Split included countries into an array
            var array2 = $$('dbllist').getValue().split(','); // Split current selected countries into an array
            var arrayAgregados = []; // Array for newly added countries
            var arrayEliminados = []; // Array for removed countries
            array2.forEach(function (obj) {
                // Iterate over selected countries
                var found = array1.find(function (element) {
                    // Check if the country was previously included
                    return element == obj;
                });
                if (found != undefined) {
                    // Country was found, do nothing
                } else {
                    arrayAgregados.push(obj); // Add to newly added countries
                }
            });
            array1.forEach(function (obj) {
                // Iterate over previously included countries
                var found = array2.find(function (element) {
                    // Check if the country is still selected
                    return element == obj;
                });
                if (found == undefined) {
                    arrayEliminados.push(obj); // Add to removed countries
                }
            });
            webix
                .ajax() // AJAX request to save changes
                .headers({
                    'Content-type': 'application/json', // Set content type to JSON
                })
                .post(
                    devConfig.geturlApi() + 'PartnersCountries/SavePartnersCountries',
                    '{"Partner":"' +
                        id_partner +
                        '","IncludedCountriesList":"' +
                        arrayAgregados +
                        '","ExcludedCountriesList":"' +
                        arrayEliminados +
                        '"}',
                    {
                        success: function (text, data, XmlHttpRequest) {
                            var data = JSON.parse(text); // Parse the response text
                            if (!data.HasError) {
                                webix.message(_('Países Partner Editado')); // Show success message
                            }
                            webix
                                .ajax() // Fetch updated countries after saving
                                .get(
                                    devConfig.geturlApi() +
                                        'PartnersCountries/GetPartnersCountries?Partner=' +
                                        id_partner,
                                    {
                                        success: function (text, data, XmlHttpRequest) {
                                            var data = JSON.parse(text); // Parse the response text
                                            if (!data.HasError) {
                                                $$('dbllist').$$('left').clearAll(); // Clear left list
                                                $$('dbllist').setValue([]); // Reset selected values
                                                $$('dbllist').parse(
                                                    data.Data.ExcludedCountriesList, // Parse updated excluded countries
                                                );
                                                $$('dbllist').setValue(
                                                    data.Data.IncludedCountriesList, // Set updated included countries
                                                );
                                                if (data.Data.IncludedCountriesList != null) {
                                                    values = data.Data.IncludedCountriesList; // Update stored included countries
                                                }
                                            }
                                        },
                                    },
                                );
                        },
                    },
                );
        });
    }
}

// FILE DOCUMENTED
